export enum EDropLocationCacheStatus {
  NoDropLocationCacheExist = 0,
  DropLocationCacheExistOnlyOnImager = 1,
  DropLocationCacheExistOnImagerAndLims = 2,
}
